import { config } from '../config';

/**
 * Hubble contextual UX surveys.
 */

declare global {
  // eslint-disable-next-line no-unused-vars
  interface Window {
    Hubble?: {
      identify: (userId: string, properties: { email: string }) => void;
    };
    hubbleInitialized?: boolean;
  }
}

export const initializeHubble = (userId: string, email: string): void => {
    const { environment } = config;

    if (environment !== 'production') {
        return;
    }

    try {
        // Script already loaded, user identified
        if (window.Hubble) {
            window.Hubble.identify(userId, { email });
            return;
        }

        if (window.hubbleInitialized) {
            return;
        }

        const sdkKey = process.env.REACT_APP_HUBBLE_API_KEY;

        if (!sdkKey) {
            console.warn('REACT_APP_HUBBLE_API_KEY key not configured.');
            return;
        }

        const hubbleScript = document.createElement('script');
        hubbleScript.type = 'text/javascript';
        hubbleScript.src = `https://sdk.hubble.team/sdk/${sdkKey}.js`;
        hubbleScript.async = true;
        document.head.appendChild(hubbleScript);

        window.addEventListener('hubble:initialized', () => {
            if (window.Hubble) {
                window.Hubble.identify(userId, { email });
            }
        }, { once: true });

        window.hubbleInitialized = true;
        console.log('Hubble initialized successfully');
    } catch (error) {
        console.error('Error initializing Hubble:', error);
    }
};
